// extracted by mini-css-extract-plugin
export default {"itemWrapper":"TodoCard_itemWrapper__FKeG3","icon":"TodoCard_icon__qIQJz","content":"TodoCard_content__rCpLs"};